export {AlbumItem as AlbumItemComponent} from './components/AlbumItemComponent'


// WEBPACK FOOTER //
// ./src/album/index.js